/* Prefer the visitor's language on their first unlocalized homepage visit.
   Country, currency and shipping eligibility remain controlled by Shopify Markets. */
(function () {
  'use strict';
  var form = document.querySelector('.nn-market-form');
  if (!form) return;
  var language = form.querySelector('[name="language_code"]');
  if (!language) return;
  var key = 'nn-language-choice';
  var read = function () { try { return localStorage.getItem(key); } catch (e) { return null; } };
  var remember = function (value) { try { localStorage.setItem(key, value); } catch (e) {} };
  document.addEventListener('submit', function (event) {
    if (event.target.matches('.nn-market-form')) {
      remember(event.target.querySelector('[name="language_code"]').value);
    }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.nn-localization[open]').forEach(function (panel) {
      panel.removeAttribute('open');
      panel.querySelector('summary').focus();
    });
  });
  // Preserve explicit locale links, cart/product links, previews and editor sessions.
  var url = new URL(window.location.href);
  if (url.pathname !== '/' || url.searchParams.has('preview_theme_id') || url.searchParams.has('_ab') || (window.Shopify && window.Shopify.designMode)) return;
  var available = Array.from(language.options).map(function (option) { return option.value.toLowerCase(); });
  var preferred = read();
  if (!preferred) {
    var languages = navigator.languages || [navigator.language || 'en'];
    preferred = languages.map(function (code) { return code.toLowerCase().split('-')[0]; }).find(function (code) { return available.indexOf(code) !== -1; });
    if (!preferred && available.indexOf('en') !== -1) preferred = 'en';
  }
  if (!preferred || available.indexOf(preferred) === -1 || language.value === preferred) return;
  try {
    if (sessionStorage.getItem('nn-language-redirect')) return;
    sessionStorage.setItem('nn-language-redirect', '1');
  } catch (e) { return; } // Do not risk a redirect loop when storage is unavailable.
  language.value = preferred;
  remember(preferred);
  if (form.requestSubmit) form.requestSubmit(); else form.submit();
})();
